import {
  whiteColor,
  successColor,
} from "assets/jss/material-dashboard-react.js";

const customTabsStyle = (theme) => ({
  cardTitle: {
    float: "left",
    padding: "10px 10px 10px 0px",
    lineHeight: "24px",
  },
  displayNone: {
    display: "none !important",
  },
  tabsRoot: {
    minHeight: "unset !important",
    overflowX: "visible",
    "& $tabRootButton": {
      fontSize: "0.875rem",
    },
  },
  tabRootButton: {
    minHeight: "unset !important",
    minWidth: "unset !important",
    width: "unset !important",
    height: "unset !important",
    maxWidth: "unset !important",
    maxHeight: "unset !important",
    padding: "12px",
    borderRadius: "15px 15px 0 0",
    lineHeight: "24px",
    border: "0 !important",
    color: whiteColor,
    backgroundColor: successColor[0],
    marginLeft: "4px",
    opacity: "1",
    marginRight: "15px",

    "&:last-child": {
      marginLeft: "0px",
    },
    textTransform: "none",
  },
  hidden: {
    display: "none",
  },
  tabSelected: {
    color: theme.palette.primary.main,
    backgroundColor: whiteColor,
    transition: "0.2s background-color 0.1s",
  },
  tabWrapper: {
    display: "inline-block",
    minHeight: "unset !important",
    minWidth: "unset !important",
    width: "unset !important",
    height: "unset !important",
    maxWidth: "unset !important",
    maxHeight: "unset !important",
    fontWeight: "500",
    fontSize: "17px",
    marginTop: "1px",
    "& > svg,& > .material-icons": {
      verticalAlign: "middle",
      margin: "-1px 5px 0 0 !important",
    },
    fontFamily: '"Gotham",Helvetica,Arial,sans-serif',
  },
});

export default customTabsStyle;
